<template lang="pug">
  label.c-tom-premium__join-checkbox.form__checkbox.form__checkbox--multiline
    input.form-ctl(
      type='checkbox',
      :checked="is_joining",
      @change="change"
    )
    span.label(style='letter-spacing: -0.04em;')
      template(v-if="is_premium_first_plan && !can_buy_with_annual_plan")
        img.c-tom-premium--inline.u-p0.u-mt0.u-mb0.u-ml0.u-mr0.u-valign-middle(
          :src="'/images/tom_premium_h.svg' | staticImageUrl",
          alt="TOM Premium",
          style='height: 15px;'
        )
        = ': '
        | Get your first {{ term }} days
        = ' '
        span(class="p-price__discount-per u-inline-block") FREE
        = ' '
        | and save
        = ' '
        span(class="p-price__discount-per u-inline-block") {{ premium_joiing_save_price | currency }}
        = ' !'
      template(v-else)
        template(v-if='can_buy_with_annual_plan')
          img.c-tom-premium--inline.u-p0.u-mt0.u-mb0.u-ml0.u-mr0.u-valign-middle(
            src="https://dzt1km7tv28ex.cloudfront.net/static/logo/TOMPremium-Symbol.svg",
            alt="TOM Premium",
            style='height: 15px;'
          )
          = ' '
          | Annual Plan: Upgrade
        template(v-else)
          | Rejoin
          = ' '
          img.c-tom-premium--inline.u-p0.u-mt0.u-mb0.u-ml0.u-mr0.u-valign-middle(
            :src="'/images/tom_premium_h.svg' | staticImageUrl",
            alt="TOM Premium",
            style='height: 15px;'
          )
        = ' '
        | for
        = ' '
        span(class="p-price__discount-per u-inline-block") {{value | currency}}
        = ' '
        | and save
        = ' '
        span(class="p-price__discount-per u-inline-block") {{ premium_joiing_save_price | currency }}
        = '!'
</template>

<script>
import textUtil from '../../../util/text';
import urlUtil from '../../../util/url';

export default {
  props: {
    is_joining: Boolean,
    is_premium_first_plan: Boolean,
    premium_joiing_save_price: Number,
    term: Number,
    value: Number,
    change: Function,
    can_buy_with_annual_plan: Boolean
  },
  filters: {
    staticImageUrl: urlUtil.staticImageUrl,
    currency: textUtil.currency
  }
};
</script>
